import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import Fade from 'react-reveal/Fade';
import view from '../../../Enums';

class StepsToPartner extends Component {


  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;
    let hSteps = 500;
    return (
      <div
        ref={this.props.setStepsToPartnerRef}
        style={
          this.props.viewMode == view.DESKTOP
            ? {
                height: '460px',
                marginTop: '80px',
                position: 'relative'
              }
            : {
                marginTop: '40px',
                position: 'relative'
              }
        }
      >
        <div style={gs('why_oyo_head')}>
          <Fade bottom>
            <div style={gs('bold_big_head')}>{gc('steps_main_heading')}</div>
            <div style={gs('bold_big_sub_head')}>
              {gc('partner_steps_content')}
            </div>
          </Fade>

          <div style={gs('steps_images_container')}>
            <div
              style={{
                ...gs('steps_images_sub_container'),
                paddingLeft: '15px'
              }}
            >
              <Fade bottom>
                <img
                  style={gs('steps_image')}
                  src={gi('partner_with_oyo_step_1')}
                />
                <br />
                <span style={gs('steps_style')}>{gc('step')}</span>
                <img
                  style={gs('partner_number_img')}
                  src={gi('partner_with_oyo_number_1')}
                />
              </Fade>
              {this.props.viewMode === view.MOBILE && (
                <div style={gs('partner_text_content')}>
                  <span style={{ width: '300px' }}>{gc('partner_step_1')}</span>
                </div>
              )}
            </div>

            {/*seperator*/}
            {this.props.viewMode == view.DESKTOP && (
              <Fade bottom>
                <img src={gi('dotted_line')} />
              </Fade>
            )}

            <div style={gs('steps_images_sub_container')}>
              <Fade bottom>
                <img
                  style={gs('steps_image')}
                  src={gi('partner_with_oyo_step_2')}
                />
                <br />
                <span style={gs('steps_style')}>{gc('step')}</span>
                <img
                  style={gs('partner_number_img')}
                  src={gi('partner_with_oyo_number_2')}
                />
              </Fade>
              {this.props.viewMode === view.MOBILE && (
                <div style={gs('partner_text_content')}>
                  <span style={{ width: '300px' }}>{gc('partner_step_2')}</span>
                </div>
              )}
            </div>

            {/*seperator*/}
            {this.props.viewMode == view.DESKTOP && (
              <Fade bottom>
                <img src={gi('dotted_line')} />
              </Fade>
            )}

            <div
              style={{
                ...gs('steps_images_sub_container'),
                paddingRight: '25px'
              }}
            >
              <Fade bottom>
                <img
                  style={gs('steps_image')}
                  src={gi('partner_with_oyo_step_3')}
                />
                <br />
                <span style={gs('steps_style')}>{gc('step')}</span>
                <img
                  style={gs('partner_number_img')}
                  src={gi('partner_with_oyo_number_3')}
                />
              </Fade>
              {this.props.viewMode === view.MOBILE && (
                <div style={gs('partner_text_content')}>
                  <span style={{ width: '300px' }}>{gc('partner_step_3')}</span>
                </div>
              )}
            </div>
          </div>

          {this.props.viewMode == view.DESKTOP && (
            <div style={gs('steps_text_container')}>
              <Fade bottom>
                <div style={gs('partner_text_content')}>
                  <span style={{ width: '300px' }}>{gc('partner_step_1')}</span>
                </div>
                <div style={{ ...gs('partner_text_content'), width: '500px' }}>
                  <span style={{ width: '300px', padding: '0px 20px' }}>
                    {gc('partner_step_2')}
                  </span>
                </div>
                <div style={gs('partner_text_content')}>
                  <span style={{ width: '300px' }}>{gc('partner_step_3')}</span>
                </div>
              </Fade>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepsToPartner);
